export const sidebarNavItems = {
    //FRL Students
    dashboard: "Dashboard",
    academicCourses: "Academic Courses",
    studentNotes: "Notes",
    profile: "Profile",

    //Customer
    booksHomePage: "Explore Books",
    bookDashboard: "My Books",

    //School Admin
    adminDashboard: "Dashboard",
    adminStudents: "Students",
    adminAttendace: "Attendance",
    adminCurriculum: "Curriculum",
    adminTeachers: "Teachers",
    adminProfile: "Profile"
}
export const courseLevelItems = [
    {
        label: "All",
        value: ""
    },
    {
        label: "Beginner",
        value: "BEGINNER"
    },
    {
        label: "Intermediate",
        value: "INTERMEDIATE"
    },
    {
        label: "Advanced",
        value: "ADVANCED"
    }
]
export const genderList = [
    {
        label: "Male",
        value: "MALE"
    },
    {
        label: "Female",
        value: "FEMALE"
    },
    {
        label: "Others",
        value: "OTHERS"
    },
]

export const S3_BUCKET_NAME = "fizrobotics-assets";
export const S3_REGION = 'ap-south-1';

export const ERROR = "error";
export const SERVER_ERROR = "Server Error";
